/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitacoesPendentesDetalhesParecerAliases {
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FORM_0 = 'form-0',
  PANEL_0 = 'panel-0',
  PANEL_SOLICITACOES_PENDENTES_DETALHES_PARECER = 'panel-solicitacoes-pendentes-detalhes-parecer',
  REPEATER_0 = 'repeater-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
}
export { SolicitacoesPendentesDetalhesParecerAliases };
